export default __webpack_public_path__ + "static/media/85.7f35da7b.png";